export const Pharmacy = {
  Header: {
    PharmacySearch: '薬局検索',
    PharmacyDetail: '薬局詳細',
    SearchResult: '検索結果',
    PrefecturesSelect: '都道府県の選択',
    Filtering: '絞り込み',
    FamilyPharmacySetting: 'かかりつけ薬局（設定）',
  },
  SearchBox: {
    Placeholder: '薬局名、郵便番号、地名',
    Button: '検索',
    PrefecturesButton: '都道府県',
    SearchAgainButton: 'このエリアを再検索',
    NoResult: '該当する薬局はありませんでした。',
    Validation: {
      InvalidSearchWordWhiteSpace:
        '検索ワードはスペース区切りの2単語で入力してください。',
      InvalidBlankSearchWord: '検索ワードを入力してください。',
    },
  },
  PharmacyList: {
    DisplayList: 'リストを表示({count}件)',
    DisplayListButton: 'リストを表示',
  },
  PharmacyDetail: {
    RegularHoliday: '定休日',
    BusinessTime: '営業時間',
    Tel: '電話番号',
    Fax: 'FAX',
    Address: '住所',
    PostCode: '〒',
    Service: '提供サービス',
    DeliveryAttention:
      '※お住まいの地域によっては当日配送できない場合がございます。',
    TransactionAttention: '特定商取引法に基づく表記',
    Family: 'かかりつけ',
    Pharmacy: '薬局',
    Call: '電話する',
    MapApp: '地図アプリ',
    Dispensing: 'お薬をもらう（調剤予約）',
    FamilyPharmacy: 'かかりつけ薬局に登録する',
    DispensingReadyCalling: 'お薬できあがり呼出登録する',
    SamePharmacyError:
      '処理中の調剤がある {name} で予約するか、前の調剤が完了してから予約してください。',
    SamePharmacyReadyCallingError:
      '処理中の調剤がございます。前の調剤が完了してから登録をしてください。',
    NoLongerAcceptReservations: '本アプリによる調剤予約受付は終了いたしました。',
  },
  FamilyPharmacy: {
    PageName: 'かかりつけ薬局',
    Button: 'かかりつけ薬局を追加する',
    UsePharmacyButton: '利用する薬局を追加する',
    AlreadyRegistError: 'かかりつけ薬局に設定されているため、変更できません。',
    MaxCountError: 'かかりつけ薬局は5件までです。',
    NoResult: 'かかりつけ薬局は登録されていません。',
    Closed: '(閉局済み店舗)',
    ClosedPharmacy: '{0}\r\nは閉局しました。',
    FamilyPharmacyLabel: 'かかりつけ薬局',
    DigitalPharmacyLabel: 'デジタル薬局(全国無料配送)',
    SelectInfo: 'かかりつけ薬局を選択してください。',
    NoLongerAcceptReservations: '本アプリによる調剤予約受付は終了いたしました。',
  },
  PharmacyService: {
    OnlineMedicationGuide: 'オンライン服薬指導',
    SameDayDelivery: '当日配送',
    NextDayOrLaterDelivery: '翌日以降配送',
    HomeVisit: '在宅訪問',
    FilteringText: '絞り込む項目を選択してください。',
    SelectAll: 'すべて選択',
    ClearAll: 'すべてクリア',
    Ok: 'OK',
  },
  Notation: {
    Title: '特定商取引法に基づく表記',
    NotFound: '準備中です。',
  },
};
